$( document ).ready(function() {

  $('.clubsticky_info').on('click', () => {
    $('.clubsticky_form').slideToggle()
  })

  $('.clubsticky_cross').on('click', () => {
    $('.clubsticky').hide();
  })

  setTimeout(function() {
    if ($('.clubsticky_form').is(":hidden")) {
      $('.clubsticky_form').slideToggle()
    }
  }, 4000);
  
  // var intervalId = window.setInterval(function(){
  //   $('.clubsticky_form').slideToggle()
  // }, 5000);

  // $('.clubsticky_info').on('click', () => {
  //   $('.clubsticky_form').slideToggle();
  //   clearInterval(intervalId);
  // })

  // $('.clubsticky_form').on('mouseover', () => {
  //   clearInterval(intervalId);
  // })
  

});